import { withAsyncLoading } from '../../../lib/PST.Web.Common/src/hocs/withAsyncPageLoading/withAsyncPageLoading';

const LoadableFormationDetailRulesPage = withAsyncLoading(async () => import('./FormationDetailRulesPage').then((res) => res.FormationDetailRulesPage));

export { LoadableFormationDetailRulesPage };
